var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternalServerError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-broken-light-bulb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}svg#freepik_stories-broken-light-bulb:not(.animated) .animable{opacity:0}svg#freepik_stories-broken-light-bulb.animated #freepik--speech-bubble--inject-2{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "249.995px 349.349px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M77.66 249.84c-95.18 55-95.17 144 0 199s249.49 55 344.67 0 95.17-144 0-199-249.49-54.95-344.67 0Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "249.995px 349.349px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "332.501px 93.3692px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-2",
    d: "M435.29 88.24a14.37 14.37 0 0 0-4.77-.88c-1.55-.12-2-.43-2.34-.76a11.38 11.38 0 0 0-13.67-4c-.91-3.7-5.38-6.91-10.31-5.83.17-4.81-6-10-11.48-11.14-5.28-1.13-9.89-.66-12.91 2.82-3.23-6.31-15.89-8.08-22.74-4.75-3.94 1.92-7.28 3.89-8.91 7.5a15 15 0 0 0-1.49 7.18c-2.67-2.35-8-3-11.58-1.61-3.84 1.49-4.14 4.38-4.33 7.33a13.53 13.53 0 0 0-7-.13c-2.43.72-3.82 2.62-3.49 4.16-1.92-.11-6.48 1.44-6 3.47.59 2.27 5.81 2 7.75 2a37 37 0 0 0 5.45-.86 8.69 8.69 0 0 0 2.84.54c3.32 0 4.72-1.45 5.26-2.68 1.62 3.41 7.38 6 11.46 7 7.68 2 18.54.77 23.26-5a8.75 8.75 0 0 0 2.29 2.79 13.31 13.31 0 0 0 7.1 2.87c3.15.3 11.61.7 14-4.31 1.69 3.33 9.22 4.85 14.94 4a23.68 23.68 0 0 0 6.42-1.94 36.19 36.19 0 0 0 3.68-2.21c1.13-.68 1.64-.67 3.15-.21 3.93 1.18 8.49 1.67 12.5 0 3.25-1.31 3.92-3.99.92-5.35Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "375.723px 80.2712px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-2",
    d: "M316.06 117.32a10.1 10.1 0 0 0-3.48-.64c-1.12-.09-1.48-.31-1.7-.56a8.29 8.29 0 0 0-10-2.94 6.38 6.38 0 0 0-7.52-4.26c.13-3.5-4.35-7.27-8.37-8.12-3.85-.82-7.22-.48-9.42 2.06C273.25 98.26 264 97 259 99.4c-2.87 1.39-5.31 2.83-6.5 5.46a11 11 0 0 0-1.09 5.24c-1.94-1.72-5.84-2.18-8.44-1.18-2.81 1.09-3 3.2-3.16 5.35a9.83 9.83 0 0 0-5.1-.09c-1.77.52-2.79 1.91-2.54 3-1.4-.08-4.73 1.05-4.35 2.53.43 1.65 4.23 1.49 5.65 1.43a25.55 25.55 0 0 0 4-.62 6.05 6.05 0 0 0 2.07.39c2.42 0 3.44-1 3.83-2 1.18 2.49 5.39 4.38 8.36 5.14 5.6 1.43 13.52.56 17-3.62a6.28 6.28 0 0 0 1.67 2 9.7 9.7 0 0 0 5.18 2.1c2.3.21 8.47.51 10.2-3.15 1.24 2.43 6.73 3.54 10.91 3a17.35 17.35 0 0 0 4.67-1.42 27.72 27.72 0 0 0 2.69-1.61 2.25 2.25 0 0 1 2.29-.16c2.87.87 6.2 1.22 9.12 0 2.31-.92 2.79-2.88.6-3.87Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "272.631px 111.449px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "54.7809px 310.535px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "54.7809px 310.535px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.52 281.41c6.29 12.13 20.39 18.7 25.59 48.76a116.78 116.78 0 0 1 1.75 25.95l11.88-6.85c2.19-12 4.18-32.64-1.77-54.11-5.16-18.68-17.28-28.7-25.2-30.62-8.88-2.13-18.85 4.11-12.25 16.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "58.1442px 310.125px"
    },
    id: "ely2127zkc6dg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 281.41c6.29 12.13 20.39 18.7 25.59 48.76a116.78 116.78 0 0 1 1.75 25.95l11.88-6.85c2.19-12 4.18-32.64-1.77-54.11-5.16-18.68-17.28-28.7-25.2-30.62-8.88-2.13-18.85 4.11-12.25 16.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "58.1442px 310.125px"
    },
    className: "animable",
    id: "el111szo2w40n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63 351a.55.55 0 0 1-.44-.62c8-34.74-7.76-67-21.5-78.76a.48.48 0 0 1 0-.72.62.62 0 0 1 .8 0c13.94 12 29.94 44.61 21.85 79.73a.54.54 0 0 1-.71.37Z",
    style: {
      fill: "#fff",
      transformOrigin: "61.0249px 310.894px"
    },
    id: "elxvyan6b23w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87 334.72c7.71 8.14 11.92 15.45 13.55 22.22l7.24-4.18c2.18-23.73-12-40.08-19-45-7.83-5.46-19.48-8.72-22.57-1.16S41 324.35 50.87 334.72Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "50.7696px 329.551px"
    },
    id: "eljui0wgl3gcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87 334.72c7.71 8.14 11.92 15.45 13.55 22.22l7.24-4.18c2.18-23.73-12-40.08-19-45-7.83-5.46-19.48-8.72-22.57-1.16S41 324.35 50.87 334.72Z",
    style: {
      fill: "#fff",
      opacity: 0.65,
      transformOrigin: "50.7696px 329.551px"
    },
    className: "animable",
    id: "el5h937875gfo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.52 353.69a.56.56 0 0 1-.45-.53c.39-17.38-19.55-42-29.51-46.67a.51.51 0 0 1-.27-.69.59.59 0 0 1 .76-.2c10.43 4.94 30.55 29.57 30.15 47.64a.5.5 0 0 1-.57.46Z",
    style: {
      fill: "#fff",
      transformOrigin: "53.7236px 329.62px"
    },
    id: "elt86ragvwjsc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "256.43px 365.88px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 392.61,
    cy: 315.39,
    rx: 71.67,
    ry: 41.38,
    style: {
      fill: "#ebebeb",
      transformOrigin: "392.61px 315.39px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 227.81,
    cy: 391.82,
    rx: 114.2,
    ry: 65.93,
    style: {
      fill: "#ebebeb",
      transformOrigin: "227.81px 391.82px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.63,
    cy: 374.44,
    rx: 71.05,
    ry: 41.02,
    style: {
      fill: "#ebebeb",
      transformOrigin: "119.63px 374.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "343.363px 216.891px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "343.363px 216.891px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "343.363px 216.891px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.75 252.71a20.56 20.56 0 0 1-10.8 13 .78.78 0 0 0-.47.76.8.8 0 0 0 .57.71c8 2.27 20.15-2.86 26.77-11.24a44.94 44.94 0 1 0-16.07-3.18Zm-23.16-24.46a43.44 43.44 0 1 1 38.88 26.07.77.77 0 0 0-.64.31c-5.55 7.23-15.85 12.14-23.24 11.39a22.44 22.44 0 0 0 9.83-13.62.8.8 0 0 0-.49-.89 43 43 0 0 1-24.34-23.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "343.363px 216.891px"
    },
    id: "el1jd3pdrhann",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.93 251.51a.8.8 0 0 1 .49.89 22.44 22.44 0 0 1-9.83 13.6c7.39.75 17.69-4.16 23.24-11.39a.77.77 0 0 1 .64-.31 43.25 43.25 0 1 0-14.54-2.81Z",
    style: {
      fill: "#fff",
      transformOrigin: "343.285px 216.942px"
    },
    id: "el8q5m08u1n1d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Thoughts--inject-2",
    className: "animable",
    style: {
      transformOrigin: "343.689px 209.53px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.31 236.06a21.09 21.09 0 1 1 3.46-.29 21.45 21.45 0 0 1-3.46.29Zm0-41.18a20.71 20.71 0 0 0-3.31.27 20.16 20.16 0 1 0 3.31-.27Z",
    style: {
      fill: "#455a64",
      transformOrigin: "335.285px 214.97px"
    },
    id: "el9ofu0flnzmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.21 236.06a21.19 21.19 0 0 1-20.81-17.68 21.12 21.12 0 1 1 24.32 17.39 21.87 21.87 0 0 1-3.51.29Zm.07-41.39a21.13 21.13 0 0 0-3.35.28 20.07 20.07 0 1 0 3.35-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "343.238px 214.94px"
    },
    id: "elzse2s4o5qmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.05 235.11a21.17 21.17 0 0 1-20.84-17.67 21.13 21.13 0 1 1 24.32 17.38 20.6 20.6 0 0 1-3.48.29Zm-20-17.82A20.23 20.23 0 1 0 348.74 194a20.26 20.26 0 0 0-16.65 23.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "352.054px 213.979px"
    },
    id: "elox5xtji023d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94 229.34a21.16 21.16 0 0 1-20.82-17.67 21.13 21.13 0 1 1 24.32 17.38 20.75 20.75 0 0 1-3.5.29ZM336 188a19.87 19.87 0 0 0-3.33.28A20.26 20.26 0 0 0 316 211.52 20.24 20.24 0 1 0 336 188Z",
    style: {
      fill: "#455a64",
      transformOrigin: "335.964px 208.209px"
    },
    id: "el7ehg83rgelp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.46 230.11a21.17 21.17 0 0 1-20.84-17.67 21.14 21.14 0 1 1 24.32 17.39 21.67 21.67 0 0 1-3.48.28Zm.05-41.38a20.27 20.27 0 0 0-20 23.57 20.22 20.22 0 1 0 20-23.57Z",
    style: {
      fill: "#455a64",
      transformOrigin: "339.474px 208.973px"
    },
    id: "el86n2fn4a2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.6 228.42a12.55 12.55 0 1 1 2.08-.17 13.26 13.26 0 0 1-2.08.17Zm-11.47-10.63a11.65 11.65 0 1 0 9.58-13.41 11.67 11.67 0 0 0-9.58 13.41Z",
    style: {
      fill: "#455a64",
      transformOrigin: "340.621px 215.87px"
    },
    id: "elxau2cjapbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.3 219.68a12.55 12.55 0 0 1-2.06-24.92 12.58 12.58 0 0 1 14.44 10.32 12.57 12.57 0 0 1-10.32 14.43 13.11 13.11 0 0 1-2.06.17Zm0-24.2a12.67 12.67 0 0 0-1.93.16 11.58 11.58 0 1 0 1.93-.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "346.326px 207.137px"
    },
    id: "elzumfyzznctp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.64 221.72a12.59 12.59 0 1 1 2.08-.18 12.26 12.26 0 0 1-2.08.18Zm0-24.2a11.42 11.42 0 0 0-1.93.16 11.58 11.58 0 1 0 1.93-.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "343.598px 209.13px"
    },
    id: "elgck6zv8mrtm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.33 214.78a12.54 12.54 0 0 1-10.2-19.78 12.55 12.55 0 0 1 22.58 5.23 12.56 12.56 0 0 1-10.32 14.43 12 12 0 0 1-2.06.12Zm0-24.19a11.66 11.66 0 0 0-11.51 13.56 11.65 11.65 0 0 0 23-3.82 11.67 11.67 0 0 0-11.47-9.74Z",
    style: {
      fill: "#455a64",
      transformOrigin: "349.353px 202.271px"
    },
    id: "el8q00xapqqck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09 215.63a11.91 11.91 0 0 1-11.71-9.94 11.9 11.9 0 1 1 11.71 9.94Zm0-22.9a10.17 10.17 0 0 0-1.82.16 11 11 0 0 0-9.05 12.65 11 11 0 1 0 10.87-12.81Z",
    style: {
      fill: "#455a64",
      transformOrigin: "345.117px 203.73px"
    },
    id: "elv38mjj50nw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.32 217.8a12.54 12.54 0 1 1 12.38-14.6 12.56 12.56 0 0 1-10.32 14.43 12 12 0 0 1-2.06.17Zm0-24.19a11.48 11.48 0 0 0-1.92.16 11.63 11.63 0 1 0 1.92-.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "334.329px 205.26px"
    },
    id: "el67hl8p15938",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.81 225.26A21.17 21.17 0 0 1 322 207.58 21.14 21.14 0 1 1 346.29 225a21.69 21.69 0 0 1-3.48.26Zm-20-17.82a20.24 20.24 0 1 0 16.65-23.29 20.25 20.25 0 0 0-16.61 23.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "342.858px 204.13px"
    },
    id: "elx00bd8ki72b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68 226.89a21.15 21.15 0 1 1 3.48-.29 20.6 20.6 0 0 1-3.48.29Zm0-41.38a20 20 0 0 0-3.33.28 20.21 20.21 0 1 0 3.33-.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "350.67px 205.74px"
    },
    id: "elsfap6xhq1io",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbols--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "180.52px 71.3041px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear shake",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Exclamation--inject-2",
    className: "animable",
    style: {
      transformOrigin: "180.52px 71.3041px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.7 71.52 3.24 1.23a1.19 1.19 0 0 0 1.49-.53L179.82 54a1 1 0 0 0-.64-1.32l-6.13-2.32a1 1 0 0 0-1.34.52l-5.8 19.35a1.15 1.15 0 0 0 .79 1.29Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "172.891px 61.5527px"
    },
    id: "elp3b9wvnvdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89 81.21a3.53 3.53 0 1 0-2-4.55 3.51 3.51 0 0 0 2 4.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "166.182px 77.9262px"
    },
    id: "elqux6by5t0gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.13 84.38 2 2.37a1.06 1.06 0 0 0 1.4.23l14.53-10.76a.89.89 0 0 0 .07-1.32l-3.83-4.48a.87.87 0 0 0-1.28-.17L180.08 83a1 1 0 0 0 .05 1.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "189.109px 78.5954px"
    },
    id: "elf27mnb3if04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5 91.23a3.17 3.17 0 1 0 .35-4.47 3.16 3.16 0 0 0-.35 4.47Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "176.907px 89.17px"
    },
    id: "elcrpfoems9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "186.063px 81.1915px"
    },
    className: "animable",
    id: "el44mywiljlg7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m180.13 84.38 2 2.37a1.06 1.06 0 0 0 1.4.23l14.53-10.76a.89.89 0 0 0 .07-1.32l-3.83-4.48a.87.87 0 0 0-1.28-.17L180.08 83a1 1 0 0 0 .05 1.38Z",
    style: {
      fill: "#fff",
      transformOrigin: "189.109px 78.5954px"
    },
    id: "elrs2bxaee9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5 91.23a3.17 3.17 0 1 0 .35-4.47 3.16 3.16 0 0 0-.35 4.47Z",
    style: {
      fill: "#fff",
      transformOrigin: "176.907px 89.17px"
    },
    id: "el21jd25idceij",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "122.144px 222.518px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "122.144px 222.518px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2",
    className: "animable",
    style: {
      transformOrigin: "124.143px 285.023px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.16 349.57c.39-11.67.61-17.12 1-37.95-.09-5.33-.1-11.05.08-16.13.6-17.1 2.64-21.24 3.89-27.14s2-16.89 3-53.66A190.31 190.31 0 0 1 91.38 173l52.33-1.85c6.18 22.81 9.69 73.18 10.36 96.89.34 12.09-5.21 73.91-4.74 78.89a16.91 16.91 0 0 0 5.42 10.65c4.47 4.49 7.63 6.26 13.18 10.12-.71 2.1-12 2.43-15.31 1a119.39 119.39 0 0 1-13.8-7.49c-4.56-3.14-5.67-5.1-5.92-10.12 0-.63-.53-4.71-.49-5-.19-2.93-4.7-37.94-6.24-47.87-1.81-11.64 1.14-27.52 1.14-27.52l-6.83-36.36s-5.4 24.48-8.23 39.38c-2.07 10.95-7.54 28.32-10.91 45.83-4 17.82-4.34 19.38-6.63 32.12-1.16 6.43-3.79 28-5.17 32.44-4.47 14.41-16 7.74-16.87-.1-.61-5.25 5.41-31.93 5.49-34.44Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "120.278px 281.869px"
    },
    id: "el1t7vvzsf26i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 375.58c.29 0 .56 3.29-1.11 4.58-1.93 1.49-7.46 3.81-14.54 2.49s-10.82-3.75-13.54-6.31-6.53-6.15-9.72-7c-3-.82-7.74-2.79-8.65-3.77s-.55-5.11-.55-5.11Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.018px 371.751px"
    },
    id: "el5wn1nj8kry2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41 346.06a2.18 2.18 0 0 0-1.22 1.35c-.29 1.12-.38 2.58-.95 4.43a33.34 33.34 0 0 0-1.25 10c.28 2.14 6.68 4.3 9.74 5.67a39.63 39.63 0 0 1 9.76 7c3.19 3 10.09 6.13 14.73 6.45 7.09.5 11.79-1.18 13.35-3.66 1.92-3.07 1.23-6.4-6.71-10.65-1.51-.8-6.75-4.32-8.53-5.59a42 42 0 0 1-5.32-4.45 32.18 32.18 0 0 1-2.35-2.61 11.22 11.22 0 0 1-1.92-2.76c-.08-.22-.13-.48-.2-.71a11 11 0 0 1-.43-1.95c-.09-.68-.12-1.68-.75-2.12s-10.85 1-11.63 2.09a6.07 6.07 0 0 0-.83 2.93c-.05.47-.06.95-.09 1.43 0 .21.05.58-.23.48s-.53-.83-.62-1.08c-.2-.55-.31-1.13-.53-1.67a4.87 4.87 0 0 0-.92-1.78c-1.29-1.22-2.61-1.07-3-1.49.02-.03-.08-.9-.1-1.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "153.223px 363.554px"
    },
    id: "eldqsib21ghpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29 366.86C160 367 156.67 375.08 156 379a23.88 23.88 0 0 0 7.21 1.94c7.09.5 12.08-1.16 13.64-3.64 1.83-2.91.57-7.3-6.56-10.44Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "166.801px 373.944px"
    },
    id: "el4ddewh720y2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.16 368a.49.49 0 0 1-.31-.13.52.52 0 0 1 0-.72c1.53-1.67 6.36-5.19 10.07-4.58a.5.5 0 1 1-.16 1c-3.46-.56-8 2.94-9.17 4.28a.49.49 0 0 1-.43.15Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "160.027px 365.253px"
    },
    id: "elo7ru9dgnzai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.88 365.17a.54.54 0 0 1-.32-.13.53.53 0 0 1 0-.72c1.53-1.68 6.36-5.2 10.07-4.58a.5.5 0 1 1-.16 1c-3.46-.57-8 2.94-9.17 4.27a.5.5 0 0 1-.42.16Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "155.738px 362.42px"
    },
    id: "el296b6m3i3dm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94 362a.43.43 0 0 1-.31-.13.49.49 0 0 1 0-.71c1.52-1.68 6.37-5.2 10.07-4.58a.49.49 0 0 1 .41.57.5.5 0 0 1-.58.42c-3.46-.56-7.95 2.94-9.16 4.27a.48.48 0 0 1-.43.16Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "151.798px 359.256px"
    },
    id: "elupjvp3dx9sg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09 358.81a.53.53 0 0 1-.31-.13.5.5 0 0 1 0-.71c2.1-2.39 7.22-5.21 10.92-4.59a.5.5 0 0 1 .42.58.52.52 0 0 1-.58.42c-3.33-.56-8.14 2.14-10 4.26a.5.5 0 0 1-.45.17Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "148.38px 356.054px"
    },
    id: "el72674hm70a9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14 385.66c-.64 4.83-1.63 8-3.56 10.71s-5.23 3.36-8.44 2.28-7.24-3.62-7.86-7.88-1-7.16.12-11.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "80.912px 389.158px"
    },
    id: "elp1pkxcr7o5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.16 349.57c-1.35 0-1.48 6.46-2.74 12.92-1.36 6.93-2.57 9.62-3.75 15.3-1.34 6.48-.48 9.48 1.51 13.62S83 400 87.37 394.66c3.6-4.37 4.12-9.49 4.31-16.05a95.19 95.19 0 0 1 2.13-16.33c1-5.24 2-10 .9-10.64a47.06 47.06 0 0 1-1.2 5.23c-.16.35-.75 1.22-.86-.16 0-.41.17-1.34.16-1.74a1.72 1.72 0 0 0-1.11-1.66 12.84 12.84 0 0 0-5.65-1.7c-2.63-.21-4.91-.47-6.43.17-.92.39-1 1.24-1.12 2.05-.19 1-.25 1.59-.47 1.37-.46-.43.22-4.92.13-5.63Z",
    style: {
      fill: "#37474f",
      transformOrigin: "83.1069px 373.341px"
    },
    id: "el3k6ohq4u99i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 381.55a16.52 16.52 0 0 0 1.78 10.14c2 4.13 10.44 8.69 14.85 3.32 2.19-2.67 3-6 3.5-9.35-2.05-4.55-16.07-7.54-20.13-4.11Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "80.9806px 388.76px"
    },
    id: "eli2f1d8ok3jt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.73 378.32a.44.44 0 0 1-.16-.06c-.06 0-6.1-3.09-12.28-2.14a.51.51 0 1 1-.16-1c6.54-1 12.71 2.14 12.94 2.27a.5.5 0 0 1-.34.93Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "82.4871px 376.627px"
    },
    id: "elcnzbvg0125k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 371.26a.5.5 0 0 1-.4-.37.51.51 0 0 1 .36-.61c6.21-1.6 12.69 2 12.93 2.15a.49.49 0 0 1 .16.69.51.51 0 0 1-.69.16c-.06 0-6.37-3.52-12.14-2a.54.54 0 0 1-.22-.02Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "83.3581px 371.612px"
    },
    id: "elq1jjwspw1x8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51 366.68a.52.52 0 0 1-.4-.36.51.51 0 0 1 .35-.62c6.84-1.89 13 2 13.18 2.12a.52.52 0 0 1 .12.71.5.5 0 0 1-.7.11s-6-3.73-12.33-2a.55.55 0 0 1-.22.04Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "83.9715px 366.96px"
    },
    id: "el6l9ededja2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18 362.17a.48.48 0 0 1-.39-.35.5.5 0 0 1 .34-.63c6.41-1.87 13 2.11 13.25 2.28a.5.5 0 0 1 .13.7.49.49 0 0 1-.69.13c-.06 0-6.46-3.88-12.41-2.14a.45.45 0 0 1-.23.01Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "84.6835px 362.54px"
    },
    id: "els4y2izmmdaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22 173.15c-1.45 14.41-2 18-3 50-1 31.05-1 35.6-1.16 39.35-.4 8.58-4.07 11.67-4.46 31.91-.36 18.55-.17 41.4-.17 41.4s2.61 3.34 9.65 3.72c6.5.36 9.65-2.2 9.65-2.2s10.49-43.57 13.46-54.56c4-14.91 9.51-41 9.51-41l5.3 29.44s-1.94 9.89-.4 26c1.23 12.82 5.19 35.5 5.19 35.5a15 15 0 0 0 9.36 2.79c8.05-.38 10-2.79 10-2.79s5.12-48.29 5.16-66.63c.05-19.41-1.14-66.69-3.21-95.18Z",
    style: {
      fill: "#455a64",
      transformOrigin: "116.846px 255.232px"
    },
    id: "el85mpdpjjygw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.74 241.74 4.13-32.26s10.47-3.18 17-10.54c-.32 5.33-9.48 12.47-13.84 13.69l-4.88 28.63 2.85 29.95Z",
    style: {
      fill: "#37474f",
      transformOrigin: "131.305px 235.075px"
    },
    id: "elydyx6irfh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.19 177.45a43.69 43.69 0 0 0-3.66 8.56 82.15 82.15 0 0 0-2.33 9c-.59 3-1.06 6.11-1.35 9.2a60 60 0 0 0-.28 9.29c.63-3 1.21-6.06 1.78-9.08s1.14-6 1.76-9 1.22-6 1.88-9 1.38-5.97 2.2-8.97Z",
    style: {
      fill: "#37474f",
      transformOrigin: "102.346px 195.475px"
    },
    id: "el4qyzau8sw4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2 178.72a32.1 32.1 0 0 0-4 4.85A44 44 0 0 0 95 189a40.69 40.69 0 0 0-2.37 5.85 24.74 24.74 0 0 0-1.2 6.21l2.57-5.67c.89-1.85 1.77-3.7 2.7-5.53s1.85-3.67 2.77-5.51 1.88-3.7 2.73-5.63Z",
    style: {
      fill: "#37474f",
      transformOrigin: "96.815px 189.89px"
    },
    id: "elixqcklwf9em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.64 214.36c-1 9.65-1.86 19.32-2.72 29s-2.83 20.35-4.26 29.9-8.27 47.12-9.39 56.74c1.87-9.52 9.8-46.88 11.32-56.5s3.25-20.38 3.84-30.07.96-19.37 1.21-29.07Z",
    style: {
      fill: "#37474f",
      transformOrigin: "100.455px 272.18px"
    },
    id: "eldu0gwwdzwcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.75 213.94 1 25.33c.13 4.22.31 8.43.4 12.65s.25 8.45.09 12.6-1.36 44.56-1 53c1.2-9.39 2.45-44.45 2.92-52.95.17-8.55-.36-17-.92-25.41s-1.38-16.84-2.49-25.22Z",
    style: {
      fill: "#37474f",
      transformOrigin: "146.471px 265.73px"
    },
    id: "elb8d7ep0neff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.79 327.83 1.09 8.84s3.42 2.39 10.8 1.91 8.54-2.82 8.54-2.82l.72-8.27s-2.23 1.65-9 2.15a28.86 28.86 0 0 1-12.15-1.81Z",
    style: {
      fill: "#37474f",
      transformOrigin: "140.365px 333.067px"
    },
    id: "eltade04pbc5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.41 329.67-.34 8.9s3 2.91 10.36 3.63 8.87-1.41 8.87-1.41l1.64-8.11s-2.07 1.33-8.81.74a29 29 0 0 1-11.72-3.75Z",
    style: {
      fill: "#37474f",
      transformOrigin: "88.505px 336.009px"
    },
    id: "elep1mptllmcs",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2",
    className: "animable",
    style: {
      transformOrigin: "122.144px 121.316px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.17 103.82c11.21 2.24 15.16 6.47 20.27 14s23.36 40 23.36 40-2.12 2.64-7.59 2.57-12.64-5.09-17.44-9-15.54-17.28-15.54-17.28Z",
    style: {
      fill: "#263238",
      transformOrigin: "157.985px 132.106px"
    },
    id: "elk1752aoxz7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-2",
    className: "animable",
    style: {
      transformOrigin: "118.105px 149.036px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.49 107.61s-4.64 14.51-2.73 28.72c1.23 9.19 2.66 16 2.91 26.8.24 10.32-.94 26.17-.94 26.17 10.89 8.64 56.85 10.82 67.23-3.05 0 0-.44-16.35-1-33.85-.45-13.05-1.8-23.11-3.33-29.26-2.48-9.94-9.53-17.3-12.43-19.32a82.52 82.52 0 0 0-24-1.77 98.68 98.68 0 0 0-25.71 5.56Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "118.129px 149.026px"
    },
    id: "elbjscicedjj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74 196.74c-14 0-27.91-2.73-33.34-7l-.21-.17v-.28c0-.16 1.17-15.94.93-26.11a151.45 151.45 0 0 0-2-20.5c-.3-2-.6-4.06-.89-6.25-1.9-14.17 2.7-28.81 2.75-28.95l.07-.24.23-.09a100 100 0 0 1 25.8-5.59 82.35 82.35 0 0 1 24.2 1.78l.18.08c3.06 2.13 10.17 9.71 12.64 19.62 1.73 6.94 2.94 17.65 3.34 29.38.59 17.29 1 33.68 1 33.84v.19l-.11.14c-4.47 6-14.6 8.43-22.32 9.43a97.29 97.29 0 0 1-12.27.72Zm-32.46-7.68c7.07 5.32 27.78 8.07 44.65 5.88 10.5-1.36 18.13-4.5 21.5-8.86-.05-1.86-.48-17.36-1-33.66-.39-11.66-1.6-22.28-3.31-29.15-2.37-9.53-9.14-16.83-12.13-19a81.62 81.62 0 0 0-23.79-1.73A99.11 99.11 0 0 0 86.92 108c-.58 1.94-4.37 15.31-2.64 28.26.29 2.18.59 4.23.89 6.23a154.6 154.6 0 0 1 2 20.63c.25 9.47-.74 23.76-.89 25.94Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "118.105px 149.036px"
    },
    id: "eld7o7lsi2vsu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2",
    className: "animable",
    style: {
      transformOrigin: "119.834px 78.9084px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 54.72s-3.43-.13-6.15 3.81c-1.36 2-2.61 5.74-.81 17.09a43.79 43.79 0 0 0 4 12.74 5.58 5.58 0 0 0 2.96 2.89l.75-8.48.36-5.93s5.35-3.76 6.26-7.94c1.17-5.39-.65-8.72-.65-8.72Z",
    style: {
      fill: "#37474f",
      transformOrigin: "105.953px 72.9848px"
    },
    id: "elro4kmj1i6gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78 54.87c1.39-4.66 8.2-9.63 20.15-8.91a22.82 22.82 0 0 1 19.38 12.64c2.75 5.94-2.59 10.15-2.59 10.15l-29.61-4.87Z",
    style: {
      fill: "#37474f",
      transformOrigin: "124.938px 57.32px"
    },
    id: "elorrac8pylm8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.53 84.35c4.23 2.64 6.68-.6 6.68-.6l-1 20.27c7.29 12.23 30.74 8.88 22.31-.61l.28-4.82a27 27 0 0 0 3.64 0c4-.16 7.52-1.8 9.18-5.87a46.86 46.86 0 0 0 2.17-8.11 31.36 31.36 0 0 0-.1-12c-.55-2.25.71-5 .41-7.73-.22-2.09-.87-4.43-2.67-5.57-4.49-2.84-9.27 0-16.19 1.76-2.86.74-9.57.44-11.23-.56 2 2.76 1.09 10.65-2.69 13.46a7.31 7.31 0 0 1-2 2c-1.59 1.07-2.41-2.25-3.49-3.64s-5.52-3-8 .87a7.93 7.93 0 0 0 2.7 11.15Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "118.446px 85.0158px"
    },
    id: "elx7gejtw3aep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84 98.59c-5.2-.62-10-1.81-12.94-3.43s-5.17-6-5.59-10.11c-.38 3.24.41 9.16 4.79 12.07s10.19 3.66 13.58 4.12Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "117.533px 93.145px"
    },
    id: "el5r9inlotdww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.32 66.79-4.6 1.32a2.44 2.44 0 0 1 1.67-3 2.36 2.36 0 0 1 2.93 1.68Z",
    style: {
      fill: "#37474f",
      transformOrigin: "121.975px 66.5651px"
    },
    id: "el4us09a7kqts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.43 69.44-4.26-2.24a2.32 2.32 0 0 1 3.19-1 2.47 2.47 0 0 1 1.07 3.24Z",
    style: {
      fill: "#37474f",
      transformOrigin: "138.419px 67.6776px"
    },
    id: "elb5b095a81b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.87 71.43a2 2 0 1 0 2.1-1.76 1.93 1.93 0 0 0-2.1 1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "122.856px 71.6643px"
    },
    id: "elcur72cvqzf6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 72.26a2 2 0 1 0 2.1-1.75 1.93 1.93 0 0 0-2.1 1.75Z",
    style: {
      fill: "#263238",
      transformOrigin: "136.985px 72.5042px"
    },
    id: "el0kxyfbwun94f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.37 67.68.21 12.32 6.8-1.62a28.54 28.54 0 0 0-7.01-10.7Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "131.875px 73.84px"
    },
    id: "elyjbmqffqqnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59 85.26c-1 1.85 1 3.24 2.52 2 1-.71 1.64-2.59.46-3.42a6.3 6.3 0 0 1 1.22-.34s.06 0 .07-.11a3.08 3.08 0 0 0-1.51-.06 3.89 3.89 0 0 0-2.76 1.93Z",
    style: {
      fill: "#b16668",
      transformOrigin: "126.59px 85.4978px"
    },
    id: "elhk6tsstgnc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.3 106.94c-10.89 2.81-14 8.24-16.54 15.59-3.71 10.47-7.38 24.62-8.48 31.47s.08 13.46 5.93 15.07S91 142.48 91 142.48s5.1-24.55-2.7-35.54Z",
    style: {
      fill: "#263238",
      transformOrigin: "77.774px 138.038px"
    },
    id: "elhnvnvhc6kjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12 100c2-2.66 2.64-5 4.84-6.21s5.67-3.74 6.88-4a3.82 3.82 0 0 1 2.36.43s1.83-1.76 2.9-1.91 1.78 1.71.87 3.52c1.06.9 1 2.38-.1 4.4.7.52 1.18 2-.42 4.81a37.79 37.79 0 0 1-2.34 3.25 21.63 21.63 0 0 0-2.86 5.68c-.7 2-.58 5.82-3.58 10.15a48.15 48.15 0 0 1-7.25 8l-8.57-9.8a60.57 60.57 0 0 1 1.35-10.68A48 48 0 0 0 98 97.41c.07-2.54 2.41-2 3.18-.47a10.56 10.56 0 0 1 .94 3.06Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "107.791px 108.211px"
    },
    id: "elnuh3e05hjfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85 118.34c-1.39 4.28-12.54 14.58-17.87 18.93s-7.26 6.68-9.35 11.18a31.72 31.72 0 0 0-1.63 18.2c.78 3.1 8 4.31 16-1.62s10.53-12.89 14.5-21.65c3.09-6.83 5.46-10.71 7.28-14.24.72-1.4 4-4.65 7-9s2.88-8.19 3.58-10.15a21.63 21.63 0 0 1 2.86-5.68 37.79 37.79 0 0 0 2.34-3.25c1.6-2.83 1.12-4.29.42-4.81 1.07-2 1.16-3.5.1-4.4.91-1.81.2-3.68-.87-3.52s-2.9 1.91-2.9 1.91a3.82 3.82 0 0 0-2.36-.43c-1.21.25-4.68 2.76-6.88 4s-2.85 3.55-4.84 6.21a10.56 10.56 0 0 0-1-3.08c-.77-1.53-3.11-2.07-3.18.47a48 48 0 0 1-1.78 10.25 60.57 60.57 0 0 0-1.35 10.68",
    style: {
      fill: "#ffbda7",
      transformOrigin: "93.09px 128.774px"
    },
    id: "el0qailfn71v0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.71 129.14c3.5-5.11 8.67-9.51 9.7-15.93l.45-2.32a14.72 14.72 0 0 1 .75-2.27 20.38 20.38 0 0 1 2.23-4.2c1.33-1.91 4.9-5.75 2.92-8l-.12-.1.07-.14c.67-1.28 1.42-3.23 0-4.25.54-1 .8-2.77-.31-3.35-1.21 0-2.28 1.22-3.18 2l-.14-.08c-1.4-.83-2.79-.37-4.08.49s-2.58 1.62-3.89 2.42c-3.11 1.32-4.14 4.58-6.1 7.07-.34-1.67-.62-4.25-2.61-4.62-1.43-.08-1.27 1.68-1.35 2.69-.28 4.29-1.75 8.38-2.46 12.57a68.27 68.27 0 0 0-.75 7.28 71.39 71.39 0 0 1 .62-7.3c.51-3.63 1.71-7.11 2.13-10.75.22-1.24.13-2.42.36-3.66a1.54 1.54 0 0 1 .51-.84c2.47-1.27 3.54 2.41 3.81 4.21l-.29-.08c1.78-2.44 3-5.63 5.93-6.9 1.29-.8 2.56-1.66 3.89-2.45a4 4 0 0 1 4.5-.51h-.26a9.94 9.94 0 0 1 2.4-1.77c2.23-1 2.54 2.31 1.7 3.63l-.05-.24c1.43 1.2.68 3.27-.06 4.64l-.05-.24c2.3 2.48-1.46 6.47-2.89 8.5a20.32 20.32 0 0 0-3.44 8.65c-1 6.48-6.34 10.81-10 15.88Z",
    style: {
      fill: "#b16668",
      transformOrigin: "107.87px 108.667px"
    },
    id: "el1a8q4fj9qog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 166.65c1 2.45 4.25 2.44 6.49 2.2 7.38-1.23 13.6-6.62 17.51-12.85 2.69-4.24 4.56-8.94 6.7-13.49s4.59-8.95 7-13.39c-2.34 4.46-4.8 8.85-6.84 13.45-4.13 9.6-7.77 18.57-17.19 24.27-3.24 1.92-7.23 3.34-11 2.28a3.64 3.64 0 0 1-2.67-2.47Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "84.85px 149.301px"
    },
    id: "eld8x9zxiz204",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 100.78a28.86 28.86 0 0 1 1.55-3.41c2-3.19 5.6-5 8.64-7.12-2.53 2.71-6 4.43-8.21 7.39-.69 1-1.27 2.12-2 3.14Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "111.085px 95.515px"
    },
    id: "elvaag1ct6bt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9 91.67c-1.37-.73-2.17 1.13-3 1.93-1.31 1.52-2.85 2.86-4.14 4.37-1.1 1.69-2.24 3.33-3.49 4.93 1.29-2.35 2.44-4.94 4.37-6.84l2.89-2.81c.86-.75 2.11-2.63 3.38-1.58Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "114.59px 97.1293px"
    },
    id: "el126yc0zeyzig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87 96.26c-1.11-.23-1.72 1-2.35 1.73-1.83 2.64-4.4 4.62-6.07 7.38a14.08 14.08 0 0 1 3.57-5.32 35.25 35.25 0 0 1 3.3-3.51 1.41 1.41 0 0 1 1.55-.28Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "115.66px 100.755px"
    },
    id: "elcdvl1wrosai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12 100a49.9 49.9 0 0 1-3.1 7 21 21 0 0 1 3.1-7Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "100.57px 103.5px"
    },
    id: "eljsyd3zv1ji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.26 97.48c-1.69-2.61-2.16-4.82-4.14-6.11s-5.08-3.85-6.19-4.15a3.52 3.52 0 0 0-2.24.25s-1.6-1.76-2.6-2-1.77 1.49-1 3.24c-1.05.78-1.05 2.17-.18 4.13-.69.44-1.23 1.77.1 4.52a35.56 35.56 0 0 0 2 3.19 20.24 20.24 0 0 1 2.32 5.49c.54 1.88.21 4.67 2.74 8.91a25.7 25.7 0 0 0 5.87 6.75l10.61-7.39s-1.39-5.22-2.18-9.34a45.11 45.11 0 0 1-1-9.7c.09-2.39-2.14-2-3-.64a9.82 9.82 0 0 0-1.11 2.85Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "148.372px 103.574px"
    },
    id: "el0oja86amsap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51 114.34c1 4.1 6.32 9.64 11 14.84 4.32 4.8 6.38 6.7 8.06 11s2.59 11.52.93 16.65c-.92 2.85-7.71 3.54-14.84-2.51s-9.07-12.72-12.24-21.16c-2.47-6.59-2.37-7.13-3.85-10.55-.59-1.36-3-3.42-5.54-7.67s-2.2-7-2.74-8.91a20.24 20.24 0 0 0-2.32-5.49 35.56 35.56 0 0 1-2-3.19c-1.33-2.75-.79-4.08-.1-4.52-.87-2-.87-3.35.18-4.13-.74-1.75 0-3.45 1-3.24s2.6 2 2.6 2a3.52 3.52 0 0 1 2.24-.25c1.11.3 4.21 2.86 6.19 4.15s2.45 3.5 4.14 6.11a9.82 9.82 0 0 1 1.09-2.82c.81-1.39 3-1.75 3 .64a45.11 45.11 0 0 0 1 9.7c.79 4.12 2.18 9.34 2.18 9.34",
    style: {
      fill: "#ffbda7",
      transformOrigin: "158.766px 122.195px"
    },
    id: "eld18cnm2mc6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57 122.65a24.33 24.33 0 0 0-2.55-3.31 41.3 41.3 0 0 1-2.48-3.38 17.56 17.56 0 0 1-3-7.78 17.23 17.23 0 0 0-1-4c-.83-2.73-2.85-4.75-4-7.33-.5-1.27-1.07-3.08.23-4.1l-.06.22a6.65 6.65 0 0 1-.64-2.2 2.32 2.32 0 0 1 .86-2.15l-.06.23c-.9-2 .25-4.89 2.61-2.76a12.45 12.45 0 0 1 1.35 1.27h-.24a3.79 3.79 0 0 1 4.18.75c1.19.82 2.32 1.7 3.49 2.53C151 92 151.88 95 153.39 97.4h-.28c.39-1.65 1.48-4.87 3.73-3.79.77.59.55 1.68.57 2.48.12 6.18 1.65 12.22 3.1 18.2-1.56-6-3.22-12-3.35-18.2 0-1 .15-2.53-1.19-2.43-1.82.32-2.23 2.63-2.63 4.15-1.69-2.45-2.46-5.56-5.28-7-1.17-.82-2.32-1.7-3.5-2.5s-2.44-1.4-3.78-.71l-.14.07c-.77-.74-1.78-2-2.86-2-1.06.47-.93 2.18-.49 3.11-1.38.87-.8 2.74-.25 4 .08.19.07.12-.07.22-1.9 1.88.86 5.5 2 7.26a20 20 0 0 1 2.47 5.79c.45 2 .53 4.16 1.36 6.11a29 29 0 0 0 4.31 7.11 24.55 24.55 0 0 1 2.48 3.37Z",
    style: {
      fill: "#b16668",
      transformOrigin: "148.242px 103.996px"
    },
    id: "el9ncpcw900ru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5 156.87c-1.88 4.29-9.16 1.86-12.06-.14-7.89-5.1-11.55-13.06-14.4-21.65-1.6-4.1-2.8-8.36-4.47-12.43 3.37 8.09 5.52 16.81 10 24.4 3.43 5.44 8.73 10.29 15.19 11.55 2 .29 4.74.36 5.75-1.73Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "165.04px 140.95px"
    },
    id: "elgcji68643f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58 98c-.62-1-1.07-2.09-1.66-3.07-1.91-2.9-5-4.74-7.23-7.42 2.7 2.18 5.95 4.08 7.64 7.2a28.49 28.49 0 0 1 1.25 3.29Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "145.135px 92.755px"
    },
    id: "eln2mn2ivly4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13 88.57c1.26-.91 2.31.93 3.08 1.68l2.53 2.82c1.7 1.88 2.59 4.39 3.66 6.66-1.07-1.57-2-3.18-3-4.82-1.1-1.5-2.48-2.84-3.59-4.35-.74-.81-1.38-2.59-2.71-2Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "141.75px 94.0264px"
    },
    id: "elwstk31jrijp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.88 92.87a1.32 1.32 0 0 1 1.44.36 35.35 35.35 0 0 1 2.87 3.48 13.35 13.35 0 0 1 3 5.21c-1.39-2.69-3.68-4.7-5.23-7.29-.53-.71-1-1.91-2.09-1.76Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "140.53px 97.3545px"
    },
    id: "el0w85d57e6gxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.26 97.48a19.51 19.51 0 0 1 2.46 6.76 46.27 46.27 0 0 1-2.46-6.76Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "154.49px 100.86px"
    },
    id: "elaq4y5llh0e5",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Piece--inject-2",
    className: "animable",
    style: {
      transformOrigin: "387.983px 284.712px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn,1.5s Infinite linear shake",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--broken-piece--inject-2",
    className: "animable",
    style: {
      transformOrigin: "387.983px 284.712px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.38 232c1.15 16.37-5.57 40.88-5.57 40.88l-27.23-11.21-13.82 34.92L364.52 284l-3.84 7.65-5.13-1.48-6.49 21.55-27.5-7.72s11.24 21.09 35.61 30.66a77.34 77.34 0 0 0 97-64.53c1.07-8.73-1.45-30.45-8.79-38.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "387.983px 284.689px"
    },
    id: "elt2dh7vl3if",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.38 232c1.15 16.37-5.57 40.88-5.57 40.88l-27.23-11.21-13.82 34.92L364.52 284l-3.84 7.65-5.13-1.48-6.49 21.55-27.5-7.72s11.24 21.09 35.61 30.66a77.34 77.34 0 0 0 97-64.53c1.07-8.73-1.45-30.45-8.79-38.13Z",
    style: {
      fill: "#fff",
      mixBlendMode: "screen",
      opacity: 0.5,
      transformOrigin: "387.983px 284.689px"
    },
    className: "animable",
    id: "el9p63cfjzf17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17 334.69c-8.2-10.6-13.06-25.13-13.83-40.2a173.26 173.26 0 0 0 45.2 8 148.59 148.59 0 0 1 6.53-17.24c11.16 4 30.65 10.21 30.65 10.21l3.86-5.59s2.46.47 4 .95c3.91-16.76 3.81-25.45 3.77-41.58 8 7.32 12.32 12.64 16.82 20.9a77.34 77.34 0 0 1-97 64.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "398.755px 293.314px"
    },
    id: "elw96itgijv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17 334.69c-8.2-10.6-13.06-25.13-13.83-40.2a173.26 173.26 0 0 0 45.2 8 148.59 148.59 0 0 1 6.53-17.24c11.16 4 30.65 10.21 30.65 10.21l3.86-5.59s2.46.47 4 .95c3.91-16.76 3.81-25.45 3.77-41.58 8 7.32 12.32 12.64 16.82 20.9a77.34 77.34 0 0 1-97 64.53Z",
    style: {
      fill: "#fff",
      opacity: 0.85,
      transformOrigin: "398.755px 293.314px"
    },
    className: "animable",
    id: "eldkuybx9zkdu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.17 270.16a67.75 67.75 0 0 0-10.57-14.77c-1.66 9.73-3.79 17.51-3.79 17.51l-3-1.24a134.23 134.23 0 0 1-3.22 19.18c-1.54-.48-4-.95-4-.95l-3.86 5.59s-12.7-4-23.47-7.7l-3.49 8.83-7.27-2.67q-1.61 4.23-2.95 8.57a173.12 173.12 0 0 1-35.14-5.16l-4.34 14.4-3.21-.9a66.39 66.39 0 0 0 11.32 23.84 76.82 76.82 0 0 0 38.62.52q3.52-.87 7-2.08c1.16-.4 2.32-.83 3.47-1.29q3.47-1.39 6.84-3.13a76.71 76.71 0 0 0 38.1-45.19c.23-.73.45-1.45.65-2.19.42-1.46.79-2.93 1.12-4.42.16-.74.32-1.49.46-2.24.29-1.49.53-3 .72-4.51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "400.015px 296.407px"
    },
    id: "el950kvwle9r8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.17 270.16a67.75 67.75 0 0 0-10.57-14.77c-1.66 9.73-3.79 17.51-3.79 17.51l-3-1.24a134.23 134.23 0 0 1-3.22 19.18c-1.54-.48-4-.95-4-.95l-3.86 5.59s-12.7-4-23.47-7.7l-3.49 8.83-7.27-2.67q-1.61 4.23-2.95 8.57a173.12 173.12 0 0 1-35.14-5.16l-4.34 14.4-3.21-.9a66.39 66.39 0 0 0 11.32 23.84 76.82 76.82 0 0 0 38.62.52q3.52-.87 7-2.08c1.16-.4 2.32-.83 3.47-1.29q3.47-1.39 6.84-3.13a76.71 76.71 0 0 0 38.1-45.19c.23-.73.45-1.45.65-2.19.42-1.46.79-2.93 1.12-4.42.16-.74.32-1.49.46-2.24.29-1.49.53-3 .72-4.51Z",
    style: {
      fill: "#fff",
      mixBlendMode: "screen",
      opacity: 0.7,
      transformOrigin: "400.015px 296.407px"
    },
    className: "animable",
    id: "elkjqhfjxwf1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-2",
    className: "animable",
    style: {
      transformOrigin: "235.345px 338.27px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bulb--inject-2",
    className: "animable",
    style: {
      transformOrigin: "235.345px 338.27px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bulb--inject-2",
    className: "animable",
    style: {
      transformOrigin: "235.345px 338.27px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.53 347.46a75.37 75.37 0 0 1-36.11 49.09c-52.87 30.52-88.09-7.3-109.4 5l-15.31 8.84-26.53-45.95 15.31-8.84c21.31-12.31 5.49-61.33 58.36-91.85a76.48 76.48 0 0 1 44.64-10.06c-3.45 10.77-3.74 19.11-4.2 25.06a147.4 147.4 0 0 0 17 4.47q-1.87 19.08-3.77 38.17c11.1 1.91 35.51 8.29 35.51 8.29l-1.54 4.59 4.69 1.13-.7 12.16s11.98 2.38 22.05-.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "249.855px 331.911px"
    },
    id: "elurr5n4jx3m9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53 347.46a75.37 75.37 0 0 1-36.11 49.09c-52.87 30.52-88.09-7.3-109.4 5l-15.31 8.84-26.53-45.95 15.31-8.84c21.31-12.31 5.49-61.33 58.36-91.85a76.48 76.48 0 0 1 44.64-10.06c-3.45 10.77-3.74 19.11-4.2 25.06a147.4 147.4 0 0 0 17 4.47q-1.87 19.08-3.77 38.17c11.1 1.91 35.51 8.29 35.51 8.29l-1.54 4.59 4.69 1.13-.7 12.16s11.98 2.38 22.05-.1Z",
    style: {
      fill: "#fff",
      mixBlendMode: "screen",
      opacity: 0.5,
      transformOrigin: "249.855px 331.911px"
    },
    className: "animable",
    id: "el1qgjjvzldic"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53 347.46a75.37 75.37 0 0 1-36.11 49.09c-52.87 30.52-88.09-7.3-109.4 5l-15.31 8.84-26.53-45.95 15.31-8.84c21.31-12.31 5.49-61.33 58.36-91.85a76.48 76.48 0 0 1 44.64-10.06c-8 4.89-13.14 9.47-20.07 17.79 16.11-.81 24.78-1.32 41.69 1.79-.4 1.55-.75 4-.75 4l5.76 3.6s-5.23 19.74-8.73 31.08a149.23 149.23 0 0 0 17.52 5.7 173.06 173.06 0 0 1-5.86 45.51c15.01-1.45 29.29-7 39.48-15.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "249.855px 331.911px"
    },
    id: "el7jumckku4p5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53 347.46a75.37 75.37 0 0 1-36.11 49.09c-52.87 30.52-88.09-7.3-109.4 5l-15.31 8.84-26.53-45.95 15.31-8.84c21.31-12.31 5.49-61.33 58.36-91.85a76.48 76.48 0 0 1 44.64-10.06c-8 4.89-13.14 9.47-20.07 17.79 16.11-.81 24.78-1.32 41.69 1.79-.4 1.55-.75 4-.75 4l5.76 3.6s-5.23 19.74-8.73 31.08a149.23 149.23 0 0 0 17.52 5.7 173.06 173.06 0 0 1-5.86 45.51c15.01-1.45 29.29-7 39.48-15.7Z",
    style: {
      fill: "#fff",
      opacity: 0.85,
      transformOrigin: "249.855px 331.911px"
    },
    className: "animable",
    id: "elo154puukl2p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.05 363.19a173.58 173.58 0 0 0 5.64-35.89c-8.1-2-19.51-4.77-26.15-5.91q1.89-19.08 3.77-38.17a147.4 147.4 0 0 1-17-4.47c.18-2.28.33-4.91.64-7.89-5 0-10.17.3-16.51.62 6.93-8.32 12-12.9 20.07-17.79a76.48 76.48 0 0 0-44.64 10.06c-52.87 30.52-37 79.54-58.36 91.85l-15.31 8.84 26.53 45.95 15.27-8.84c21.31-12.3 56.53 25.52 109.4-5a75.37 75.37 0 0 0 36.11-49.09c-10.17 8.7-24.45 14.25-39.46 15.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "249.855px 331.911px"
    },
    id: "elazc48kqefro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.05 363.19a173.58 173.58 0 0 0 5.64-35.89c-8.1-2-19.51-4.77-26.15-5.91q1.89-19.08 3.77-38.17a147.4 147.4 0 0 1-17-4.47c.18-2.28.33-4.91.64-7.89-5 0-10.17.3-16.51.62 6.93-8.32 12-12.9 20.07-17.79a76.48 76.48 0 0 0-44.64 10.06c-52.87 30.52-37 79.54-58.36 91.85l-15.31 8.84 26.53 45.95 15.27-8.84c21.31-12.3 56.53 25.52 109.4-5a75.37 75.37 0 0 0 36.11-49.09c-10.17 8.7-24.45 14.25-39.46 15.73Z",
    style: {
      fill: "#fff",
      mixBlendMode: "screen",
      opacity: 0.7,
      transformOrigin: "249.855px 331.911px"
    },
    className: "animable",
    id: "el35ywky91gl4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.49 355.6-15.31 8.84 5.89 10.2c7.52-6.29 15.84-13.44 19.3-17.1 7-7.38 3.62-26.85 8.58-44.57-6.29 19.03-7.1 36.03-18.46 42.63Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.15,
      transformOrigin: "173.065px 343.805px"
    },
    className: "animable",
    id: "elq7wxq2y4dpe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.4 401.19 5.35 9.17 15.25-8.81c11.17-6.45 26.17.87 45.52 4.91C226 401.84 211 389.61 201.28 392c-4.89 1.19-15.22 4.87-24.41 8.28Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.15,
      transformOrigin: "210.195px 401.027px"
    },
    className: "animable",
    id: "elpfxhuz1u88g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31 381.7a.79.79 0 0 1-.65-.33.81.81 0 0 1 .19-1.12l26.86-19a39.94 39.94 0 0 0 11.53-12.7l14.93-26.06a11.2 11.2 0 0 1 8.93-5.61c4.1-.29 7.34.16 9.67 1.36l.47-.2c6.51-2.5 15.53-2.63 20.77 1.76a23.08 23.08 0 0 1 4.18-.84 16.55 16.55 0 0 1 6.94.5 9.4 9.4 0 0 1 5.54 4.46.8.8 0 0 1-1.43.73 7.77 7.77 0 0 0-4.6-3.67 15.08 15.08 0 0 0-6.27-.43 21.85 21.85 0 0 0-3 .55 12.5 12.5 0 0 1 3.08 8.09A8.17 8.17 0 0 1 262 334a7 7 0 0 1-6.53 2.59 7.05 7.05 0 0 1-5.7-4.76 8.29 8.29 0 0 1 2-7.56 14.06 14.06 0 0 1 5.44-3.89c-4.68-3.27-12.12-3.13-17.81-1.12 3.65 2.92 3.87 6.44 2.91 8.63a5.72 5.72 0 0 1-6.55 3.26 4.57 4.57 0 0 1-3.94-4.21c-.23-2.76 1.55-5.87 4.21-7.77a20 20 0 0 0-7.83-.75 9.57 9.57 0 0 0-7.65 4.81l-14.93 26.06a41.65 41.65 0 0 1-12 13.2c-6.07 4.31-15.54 11-26.85 19.05a.86.86 0 0 1-.46.16Zm92.32-60.12a13 13 0 0 0-5.62 3.74c-1.24 1.48-2.33 3.85-1.66 6.07a5.46 5.46 0 0 0 4.4 3.63 5.33 5.33 0 0 0 5-1.94 6.73 6.73 0 0 0 1.07-3.92 10.91 10.91 0 0 0-3.19-7.58ZM237.71 320c-2.81 1.58-4.47 4.62-4.28 6.81a3 3 0 0 0 2.66 2.77 4.14 4.14 0 0 0 4.76-2.33c.81-1.83.47-4.66-2.89-7.08a2.2 2.2 0 0 0-.25-.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "220.635px 349px"
    },
    id: "eljr1zgzfhzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.66 394.43a.82.82 0 0 1-.73-.47.8.8 0 0 1 .4-1.06c12.61-5.78 23.15-10.63 29.91-13.74a41.71 41.71 0 0 1 17.44-3.79l30 .1a9.58 9.58 0 0 0 7.95-4.22 20.1 20.1 0 0 0 3.37-7.15c-3 1.35-6.56 1.34-8.84-.24a4.55 4.55 0 0 1-1.67-5.51 5.71 5.71 0 0 1 6.1-4.05c2.38.26 5.31 2.22 6 6.83a10.61 10.61 0 0 0 3.94-7 .8.8 0 1 1 1.59.15 12.57 12.57 0 0 1-5 8.55l-.4.31c-.13 2.61-1.35 5.65-3.66 9a11.18 11.18 0 0 1-9.28 4.93l-30-.1h-.13a40 40 0 0 0-16.64 3.65c-6.76 3.11-17.3 7.95-29.92 13.73a.76.76 0 0 1-.43.08Zm83.26-38.57a4.17 4.17 0 0 0-3.94 3 3 3 0 0 0 1.07 3.69c1.8 1.26 5.26 1.34 8-.31v-.29c-.42-4.13-2.69-5.83-4.68-6.05a3.55 3.55 0 0 0-.45-.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "220.994px 373.896px"
    },
    id: "el784r1uyj3ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.79 410.52c3.41-2 5.52-6.2 5.52-12.22 0-12-8.45-26.67-18.87-32.68-5.21-3-9.93-3.3-13.34-1.32l-7.86 4.53c-3.41 2-5.52 6.21-5.52 12.23 0 12 8.46 26.67 18.87 32.68 5.22 3 9.93 3.29 13.35 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "165.515px 389.678px"
    },
    id: "elfffhnhzvadd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Socket--inject-2",
    className: "animable",
    style: {
      transformOrigin: "151.58px 396.913px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 383.59c0-11.5 8.07-16.16 18-10.41s18 19.73 18 31.23-8.07 16.16-18 10.41-18-19.73-18-31.23Z",
    style: {
      fill: "#37474f",
      transformOrigin: "158px 394px"
    },
    id: "elen6puh5uwrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.36 385.6c0-11.24 7.89-15.79 17.62-10.18s17.62 19.28 17.62 30.52-7.89 15.79-17.62 10.17-17.62-19.28-17.62-30.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "154.98px 395.768px"
    },
    id: "eltbfkq117ltb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.72 387.6c0-11 7.7-15.42 17.2-9.93s17.2 18.83 17.2 29.8-7.7 15.42-17.2 9.93-17.2-18.83-17.2-29.8Z",
    style: {
      fill: "#37474f",
      transformOrigin: "151.92px 397.532px"
    },
    id: "elq02nopf69sh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07 389.61c0-10.71 7.52-15.05 16.79-9.7s16.79 18.38 16.79 29.08-7.52 15.05-16.79 9.7-16.79-18.38-16.79-29.08Z",
    style: {
      fill: "#455a64",
      transformOrigin: "148.86px 399.299px"
    },
    id: "elt51zd4geixc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43 391.61c0-10.44 7.33-14.67 16.37-9.45s16.38 17.92 16.38 28.36-7.33 14.68-16.38 9.48-16.37-17.95-16.37-28.39Z",
    style: {
      fill: "#37474f",
      transformOrigin: "145.805px 401.073px"
    },
    id: "elwjqqvscnbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.16 393.6c0-10.07 7.07-14.15 15.79-9.12s15.79 17.28 15.79 27.35-7.07 14.17-15.74 9.11-15.84-17.28-15.84-27.34Z",
    style: {
      fill: "#455a64",
      transformOrigin: "142.95px 402.718px"
    },
    id: "elvpm5aejkjld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67 398.07c0-6.81 4.75-9.59 10.66-6.2s10.71 11.66 10.73 18.47-4.76 9.58-10.66 6.19-10.71-11.66-10.73-18.46Z",
    style: {
      fill: "#263238",
      transformOrigin: "140.365px 404.201px"
    },
    id: "eliedoq17q4sl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.06 418-1.23-2.12a7.57 7.57 0 0 0 1.12-4.28c0-5.54-3.92-12.26-8.73-15a7.48 7.48 0 0 0-4.26-1.15l-1.23-2.11-2.44 4.66a8.28 8.28 0 0 0-.74 3.63c0 5.54 3.92 12.26 8.73 15a8 8 0 0 0 3.52 1.15Z",
    style: {
      fill: "#263238",
      transformOrigin: "136.304px 405.67px"
    },
    id: "elqb8jz16iiyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.24 403.89c0-4.05 2.82-5.69 6.33-3.68a14 14 0 0 1 6.37 11c0 4.05-2.82 5.69-6.33 3.68a14 14 0 0 1-6.37-11Z",
    style: {
      fill: "#37474f",
      transformOrigin: "134.59px 407.55px"
    },
    id: "el8drl3oez3y8",
    className: "animable"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalServerError);
export default __webpack_public_path__ + "static/media/internalServerError.5ae67d6c6995e8dc48ccc326c583dcbf.svg";
export { ForwardRef as ReactComponent };